import React from 'react'
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Main } from './Main';

function Cart() {
  return (
    <>
    <Header/>
    
  
    <Main/>
   


      <Footer/>
    </>
  )
}

export default Cart

